export default __webpack_public_path__ + "static/media/logo.d623f8e9.png";